import { colors } from '@mui/material';

const white = '#FFFFFF';
const black = '#212121';

export default {
  primary: {
    contrastText: white,
    dark: '#5da300',
    main: '#4CAF50',
    light: '#c7ff4f',
    text: 'black',
  },
  secondary: {
    contrastText: white,
    dark: '#00411e',
    main: '#006d46',
    light: '#439c72',
  },
  success: {
    contrastText: white,
    dark: colors.green[900],
    main: colors.green[600],
    light: colors.green[400],
  },
  info: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue[600],
    light: colors.blue[400],
  },
  warning: {
    contrastText: white,
    dark: colors.orange[900],
    main: colors.orange[600],
    light: colors.orange[400],
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[500],
    light: colors.red[400],
  },
  text: {
    primary: black,
    secondary: '#949494',
    link: '#93D500',
  },
  background: {
    default: '#ffffff',
    paper: white,
  },
  icon: colors.blueGrey[600],
  divider: colors.grey[200],
  border: '#E0E0E0',
};
